<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="10%" v-if="!isOperator")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="10%")
          span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
        th(width="35%")
          span(:title="$t('ui.promo_name')") {{ $t('ui.promo_name') }}
        th.text-right(width="20%")
          span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
        th.text-right(width="15%")
          span(:title="$t('ui.withdrawal_count')") {{ $t("ui.withdrawal_count") }}
        th.text-right(width="15%")
          span(:title="$t('ui.unique_player')") {{ $t("ui.unique_player") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="!isOperator ? '7' : '6'").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td(v-if="!isOperator")
          span(:title="item.operator_id") {{ item.operator_id }}
        td
          span(:title="item.promotion_id") {{ item.promotion_id }}
        td
          span(:title="item.promotion_name") {{ item.promotion_name }}
        td.text-right
          span.font-weight-bold(:title="$n(item.withdrawal_amount, 'currency')" :class="$helpers.fontClassName(item.withdrawal_amount)") {{ $n(item.withdrawal_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.withdrawal_count, 'integer')") {{ $n(item.withdrawal_count, 'integer') }}
        td.text-right
          span(:title="$n(item.unique_player, 'integer')") {{ $n(item.unique_player, 'integer') }}
      tr.footer
        td.text-right(:colspan="!isOperator ? '4' : '3'")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWithdrawalAmount)" :title="$n(subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(subTotalWithdrawalCount, 'integer')") {{ $n(subTotalWithdrawalCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:title="$n(subTotalUniquePlayer, 'integer')") {{ $n(subTotalUniquePlayer, 'integer') }}
      tr.footer
        td.text-right(:colspan="!isOperator ? '4' : '3'")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalAmount)" :title="$n(grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(grandTotalWithdrawalCount, 'integer')") {{ $n(grandTotalWithdrawalCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:title="$n(grandTotalUniquePlayer, 'integer')") {{ $n(grandTotalUniquePlayer, 'integer') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalWithdrawalAmount: 0,
    subTotalWithdrawalCount: 0,
    subTotalUniquePlayer: 0,
    grandTotalWithdrawalAmount: 0,
    grandTotalWithdrawalCount: 0,
    grandTotalUniquePlayer: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalWithdrawalAmount = 0
      this.subTotalWithdrawalCount = 0
      this.subTotalUniquePlayer = 0
      this.grandTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalCount = 0
      this.grandTotalUniquePlayer = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"] || 0);
          this.subTotalWithdrawalCount = parseFloat(this.subTotalWithdrawalCount) + parseFloat(value["withdrawal_count"] || 0);
          this.subTotalUniquePlayer = parseFloat(this.subTotalUniquePlayer) + parseFloat(value["unique_player"] || 0);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalWithdrawalAmount = totalTbl[0]["withdrawal_amount"];
          this.grandTotalWithdrawalCount = totalTbl[0]["withdrawal_count"];
          this.grandTotalUniquePlayer = totalTbl[0]["unique_player"];
        }
      }
    }
  }
};
</script>
